/**
 * Route for `campaign-tz-scheduling`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignTzSchedulingPage } from "../features/campaign-tz-scheduling/CampaignTzSchedulingPage";

export const campaignTzSchedulingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-tz-scheduling",
	component: CampaignTzSchedulingPage,
});

export default campaignTzSchedulingRoute;
